import { StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	useCase: 'useCase',
	expName: 'expName',
	desc: 'desc',
	createdAt: 'createdAt',
	createdBy: 'createdBy',
	updatedAt: 'updatedAt',
	updatedBy: 'updatedBy'
};

export const columnConfigs = [
	StringColumn({
		title: 'Use Case',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.useCase] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Segment Name',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.expName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.desc] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	StringColumn({
		title: 'Created By',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	}),
	StringColumn({
		title: 'Updated By',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	})
];
